import React, {Component, createRef} from "react";
import "../../../../style/paymentHistory.css"
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import {Box, Button, CircularProgress, MenuItem, Select} from "@mui/material";
import {RiDownloadCloud2Fill} from "react-icons/ri";
import {MdOutlineDeleteOutline, MdOutlineEdit} from "react-icons/md";
import Modal from "react-bootstrap/Modal";
import {formatAmountInputWhileTyping, formatDisplayAmount, normalizeNumericInput} from '../../../../utils/persianDate';
import {paymentFileInfo} from '../../../../utils/paymentFile';
import {green} from "@mui/material/colors";
import Skeleton from "react-loading-skeleton";
import FormControl from "@mui/material/FormControl";
import axios from "axios";
import { API_BASE_URL } from '../../../../api/client';
import ListPagination, {paginateItems} from '../../../CustomInputs/ListPagination';

class PaymentHistory extends Component {

    constructor(props) {
        super(props);
        if (localStorage.getItem('role') !== 'MANAGER') {window.location = "/dashboard"}
    }

    state = {
        searchLoading: true,
        loading: false,
        payment: [],
        paymentFilter: [],
        typeTransaction: 'all',
        dataPickerStart: null,
        dataPickerEnd: null,
        dateStart: '',
        dateEnd: '',
        totalPayment: "",
        totalReceive: "",
        listPage: 1,
        pageSize: 20,
        showEditModal: false,
        editSaving: false,
        editForm: null,
        showDeleteModal: false,
        deleteTarget: null,
        deleteLoading: false,
    }

    async componentDidMount() {
        this.setState({searchLoading: true})
        axios.get(`${API_BASE_URL}/api/v1/supervisor/account`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
            .then((data) => {
                this.setState({
                    totalPayment: data.totalPayment,
                    totalReceive: data.totalReceived})
            }).catch(() => {
            if (localStorage.getItem('role') === 'MANAGER') {
                axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.get(`${API_BASE_URL}/api/v1/supervisor/account`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                .then((data) => {
                                    this.setState({
                                        totalPayment: data.totalPayment,
                                        totalReceive: data.totalReceived})
                                })
                        } else {
                            window.location = '/'
                        }
                    })
            } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.get(`${API_BASE_URL}/api/v1/supervisor/account`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                .then((data) => {
                                    this.setState({
                                        totalPayment: data.totalPayment,
                                        totalReceive: data.totalReceived})
                                })
                        } else {
                            window.location = '/'
                        }
                    })
            }})
        axios.get(`${API_BASE_URL}/api/v1/supervisor/paymentHistory`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
            .then((data) => {
                this.setState({payment : data, searchLoading: false})
            }).catch(() => {
            if (localStorage.getItem('role') === 'MANAGER') {
                axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.get(`${API_BASE_URL}/api/v1/supervisor/paymentHistory`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                .then((data) => {
                                    this.setState({payment : data, searchLoading: false})})
                        } else {
                            window.location = '/'
                        }
                    })
            } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.get(`${API_BASE_URL}/api/v1/supervisor/paymentHistory`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                .then((data) => {
                                    this.setState({payment : data, searchLoading: false})})
                        } else {
                            window.location = '/'
                        }
                    })
            }})

    }

    render() {
        return (
            <>
                <div className="page-title-row">
                    <h4>صورتحساب</h4>
                </div>
                <div className="d-flex flex-row flex-wrap mb-3">
                    <div className='d-flex flex-row ms-3'>
                        <span className="mx-2">هزینه کل: </span>
                        <span>{formatDisplayAmount(this.state.totalPayment)} ريال </span>
                    </div>
                    <div className='d-flex flex-row'>
                        <span className="mx-2">درآمد کل:  </span>
                        <span>{formatDisplayAmount(this.state.totalReceive)} ريال </span>
                    </div>
                </div>
                <div className="search-box search-toolbar">
                    <div className="search-field">
                        <span className="search-field-label">نوع تراکنش</span>
                        <FormControl fullWidth size="small">
                            <Select
                                className="search-select"
                                id="select-field"
                                value={this.state.typeTransaction}
                                onChange={(value) => this.setState({typeTransaction: value.target.value})}>
                                <MenuItem value={"all"}> همه تراکنش ها</MenuItem>
                                <MenuItem value={"expend"}>پرداخت</MenuItem>
                                <MenuItem value={"receive"}>دریافت</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div className="search-field">
                        <span className="search-field-label">از تاریخ</span>
                        <div className="search-input-wrap">
                            <DatePicker
                                calendarPosition={`top`}
                                digits={['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']}
                                format={`YYYY/MM/DD`}

                                containerStyle={{
                                    width: "100%"
                                }}

                                inputClass=""
                                value={this.state.dateStart}
                                onChange={(value) => {
                                    this.handleDateStartInput(value)
                                }}

                                mapDays={({ date }) => {
                                    let props = {}
                                    let isWeekend = [6].includes(date.weekDay.index)

                                    if (isWeekend)
                                        props.className = "highlight highlight-red";

                                    return props
                                }}

                                weekDays={
                                    [
                                        ["شنبه", "Sat"],
                                        ["یکشنبه", "Sun"],
                                        ["دوشنبه", "Mon"],
                                        ["سه شنبه", "Tue"],
                                        ["چهارشنبه", "Wed"],
                                        ["پنجشنبه", "Thu"],
                                        ["جمعه", "Fri"],
                                    ]
                                }

                                calendar={persian}
                                locale={persian_fa}

                            >
                                <Button
                                    onClick={() => {
                                        this.setState({dateStart: {}})
                                    }
                                    }
                                >
                                    ریست
                                </Button>
                            </DatePicker>
                        </div>
                    </div>
                    <div className="search-field">
                        <span className="search-field-label">تا تاریخ</span>
                        <div className="search-input-wrap">
                            <DatePicker
                                calendarPosition={`top`}
                                digits={['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']}
                                format={`YYYY/MM/DD`}

                                containerStyle={{
                                    width: "100%"
                                }}

                                inputClass=""
                                value={this.state.dateEnd}
                                onChange={(value) => {
                                    this.handleDateEndInput(value)
                                }}

                                mapDays={({ date }) => {
                                    let props = {}
                                    let isWeekend = [6].includes(date.weekDay.index)

                                    if (isWeekend)
                                        props.className = "highlight highlight-red";

                                    return props
                                }}

                                weekDays={
                                    [
                                        ["شنبه", "Sat"],
                                        ["یکشنبه", "Sun"],
                                        ["دوشنبه", "Mon"],
                                        ["سه شنبه", "Tue"],
                                        ["چهارشنبه", "Wed"],
                                        ["پنجشنبه", "Thu"],
                                        ["جمعه", "Fri"],
                                    ]
                                }

                                calendar={persian}
                                locale={persian_fa}

                            >
                                <Button
                                    onClick={() => {
                                        this.setState({dateEnd: {}})
                                    }
                                    }
                                >
                                    ریست
                                </Button>
                            </DatePicker>
                        </div>
                    </div>
                    <div className="search-field">
                        <span className="search-field-label">تعداد تراکنش</span>
                        <div className="search-input-wrap">
                            <input type="text" ref={this.count}/>
                        </div>
                    </div>
                    <div className="search-field">
                        <span className="search-field-label">&nbsp;</span>
                        <Box sx={{ position: 'relative' }}>
                            <Button
                                className={"buttonDone"}
                                variant="contained"
                                disabled={this.state.loading}
                                onClick={this.handleSubmit}
                            >
                                مشاهده
                            </Button>
                            {this.state.loading && (
                                <CircularProgress
                                    size={24}
                                    sx={{
                                        color: green[500],
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: '-12px',
                                        marginLeft: '-12px',
                                    }}
                                />
                            )}
                        </Box>
                    </div>
                </div>
                <div className="table-box">
                    <table className='table'>
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>نوع تراکنش</th>
                            <th>نوع</th>
                            <th>تاریخ</th>
                            <th>مبلغ</th>
                            <th>پرداخت کننده</th>
                            <th>توضیحات</th>
                            <th>فايل فاكتور</th>
                            <th>عملیات</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            this.state.searchLoading ?
                                [...Array(5)].map((x, i) =>
                                    <tr key={i}>
                                        <td><Skeleton animation="wave" height={20} width="100%" /></td>
                                        <td><Skeleton animation="wave" height={20} width="100%" /></td>
                                        <td><Skeleton animation="wave" height={20} width="100%" /></td>
                                        <td><Skeleton animation="wave" height={20} width="100%" /></td>
                                        <td><Skeleton animation="wave" height={20} width="100%" /></td>
                                        <td><Skeleton animation="wave" height={20} width="100%" /></td>
                                        <td><Skeleton animation="wave" height={20} width="100%" /></td>
                                        <td><Skeleton animation="wave" height={20} width="100%" /></td>
                                        <td><Skeleton animation="wave" height={20} width="100%" /></td>
                                    </tr>
                                )
                                :
                                (() => {
                                    const {pageItems, page} = paginateItems(
                                        this.state.payment || [], this.state.listPage, this.state.pageSize
                                    );
                                    if (pageItems.length === 0) {
                                        return (
                                            <tr className="table-empty-row">
                                                <td colSpan={9}>موردی یافت نشد</td>
                                            </tr>
                                        );
                                    }
                                    return pageItems.map((peyment, index) => {
                                        const fileInfo = paymentFileInfo(peyment.file);
                                        const amountRaw = peyment.amount?.value ?? peyment.value ?? '';
                                        return (
                                <tr key={peyment.id || index}>
                                    <td>{(page - 1) * this.state.pageSize + index + 1}</td>
                                    <td>{peyment.paymentType === "expend" ? ("پرداخت"):("دریافت")}</td>
                                    <td>{peyment.type}</td>
                                    <td>{peyment.date}</td>
                                    <td>{formatDisplayAmount(amountRaw)} {peyment.amount?.unit ? peyment.amount.unit : ''}</td>
                                    <td>{peyment.parentId}</td>
                                    <td>{peyment.description}</td>
                                    <td>{fileInfo ? (
                                        <div className="record-item"
                                             onClick={() => this.downloadFile(peyment.file)}
                                             title={fileInfo.name}>
                                            <div className='ms-2'>{fileInfo.name}</div>
                                            <RiDownloadCloud2Fill/>
                                        </div>
                                    ) : '—'}
                                    </td>
                                    <td>
                                        <div className="table-actions">
                                            <button type="button" className="icon-btn" title="ویرایش"
                                                    onClick={() => this.openEditModal(peyment)}>
                                                <MdOutlineEdit size={15}/>
                                            </button>
                                            <button type="button" className="icon-btn icon-btn-danger" title="حذف"
                                                    onClick={() => this.setState({showDeleteModal: true, deleteTarget: peyment})}>
                                                <MdOutlineDeleteOutline size={15}/>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                                        );
                                    });
                                })()
                        }
                        </tbody>
                    </table>
                </div>
                <Modal centered show={this.state.showEditModal} onHide={this.closeEditModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>ویرایش فاکتور</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.editForm ? (
                            <div className="d-flex flex-column gap-3">
                                <input className="form-control" placeholder="پرداخت کننده"
                                       value={this.state.editForm.parentId}
                                       onChange={(e) => this.setState({
                                           editForm: {...this.state.editForm, parentId: e.target.value}
                                       })}/>
                                <input className="form-control" placeholder="مبلغ"
                                       value={this.state.editForm.valueDisplay}
                                       onChange={(e) => this.setState({
                                           editForm: {
                                               ...this.state.editForm,
                                               valueDisplay: formatAmountInputWhileTyping(e.target.value),
                                           }
                                       })}/>
                                <input className="form-control" placeholder="توضیحات"
                                       value={this.state.editForm.description}
                                       onChange={(e) => this.setState({
                                           editForm: {...this.state.editForm, description: e.target.value}
                                       })}/>
                            </div>
                        ) : null}
                    </Modal.Body>
                    <Modal.Footer className="justify-content-center">
                        <button className="btn btn-success" disabled={this.state.editSaving}
                                onClick={this.saveEditPayment}>ذخیره</button>
                        <button className="btn btn-light" onClick={this.closeEditModal}>بستن</button>
                    </Modal.Footer>
                </Modal>
                <Modal centered show={this.state.showDeleteModal} onHide={() => this.setState({showDeleteModal: false, deleteTarget: null})}>
                    <Modal.Header closeButton>
                        <Modal.Title>حذف فاکتور</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>آیا از حذف این ردیف مطمئن هستید؟</Modal.Body>
                    <Modal.Footer className="justify-content-center">
                        <button className="btn btn-danger" disabled={this.state.deleteLoading}
                                onClick={this.confirmDeletePayment}>حذف</button>
                        <button className="btn btn-light"
                                onClick={() => this.setState({showDeleteModal: false, deleteTarget: null})}>انصراف</button>
                    </Modal.Footer>
                </Modal>
                {(() => {
                    if (this.state.searchLoading) return null;
                    const {totalPages, page, total} = paginateItems(
                        this.state.payment || [], this.state.listPage, this.state.pageSize
                    );
                    return (
                        <>
                            <div className="text-muted small text-center mt-2">از {total} مورد</div>
                            <ListPagination page={page} totalPages={totalPages}
                                            onNewPage={(p) => this.setState({listPage: p})}/>
                        </>
                    );
                })()}
            </>
        )
    }

    type = createRef();
    startDate = createRef();
    endDate = createRef();
    count = createRef();


    handleDateStartInput = (value) => {
        // this.setState({dataPickerStart: value})
        // let date = new Date(value._d);
        // let convertDate = date.getFullYear() + "/" + date.getMonth() + "/" + date.getDate() + " 00:00:00";
        let month = value.month < 10 ? ('0' + value.month) : value.month;
        let day = value.day < 10 ? ('0' + value.day) : value.day;
        let convertDate = value.year  + '/' + month + '/' + day;
        this.setState({dateStart: convertDate})
    }
    handleDateEndInput = (value) => {
        // this.setState({dataPickerEnd: value})
        // let date = new Date(value._d);
        // let convertDate = date.getFullYear() + "/" + date.getMonth() + "/" + date.getDate() + " 00:00:00";
        let month = value.month < 10 ? ('0' + value.month) : value.month;
        let day = value.day < 10 ? ('0' + value.day) : value.day;
        let convertDate = value.year  + '/' + month + '/' + day;
        this.setState({dateEnd: convertDate})
    }
    handleSubmit = async () => {
        let type;
        switch (this.state.typeTransaction) {
            case 'all': {
                type = ["receive", "expend"];
                break;
            }
            case 'receive': {
                type = ["receive"];
                break;
            }
            case 'expend': {
                type = ["expend"];
                break;
            }
        }

        let startDate = this.state.dateStart;
        if(Object.keys(startDate).length === 0){
             startDate = "";
        }

        let endDate = this.state.dateEnd;
        if(Object.keys(endDate).length === 0){
             endDate = "";
        }

        const count = parseInt(this.count.current.value);
        const result = {
            paymentType: type,
            count: count,
            startDate: startDate,
            endDate: endDate
        }
        this.setState({loading: true, searchLoading: true, listPage: 1})
        axios.post(`${API_BASE_URL}/api/v1/supervisor/paymentHistory/filter`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
            .then((data) => this.setState({payment: data, loading: false, searchLoading: false})).catch(() => {
            if (localStorage.getItem('role') === 'MANAGER') {
                axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.post(`${API_BASE_URL}/api/v1/supervisor/paymentHistory/filter`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                .then((data) => this.setState({payment: data, loading: false, searchLoading: false}))
                        } else {
                            window.location = '/'
                        }
                    })
            } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.post(`${API_BASE_URL}/api/v1/supervisor/paymentHistory/filter`, result, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                .then((data) => this.setState({payment: data, loading: false, searchLoading: false}))
                        } else {
                            window.location = '/'
                        }
                    })
            }})
        this.setState({loading: false, searchLoading: false})
    }

    openEditModal = (payment) => {
        const amountRaw = payment.amount?.value ?? payment.value ?? '';
        this.setState({
            showEditModal: true,
            editForm: {
                id: payment.id,
                parentId: payment.parentId || '',
                description: payment.description || '',
                valueDisplay: formatDisplayAmount(amountRaw),
                unit: payment.amount?.unit || 'IRR',
                type: payment.type,
                paymentType: payment.paymentType,
                date: payment.date,
            },
        });
    }

    closeEditModal = () => {
        this.setState({showEditModal: false, editForm: null, editSaving: false});
    }

    saveEditPayment = async () => {
        const form = this.state.editForm;
        if (!form?.id) return;
        const payload = {
            date: form.date,
            unit: form.unit,
            value: normalizeNumericInput(form.valueDisplay),
            type: form.type,
            paymentType: form.paymentType,
            description: form.description,
            parentId: form.parentId,
            parentType: 'Personnel',
        };
        this.setState({editSaving: true});
        try {
            await axios.put(`${API_BASE_URL}/api/v1/supervisor/paymentHistory/${form.id}`, payload, {
                headers: {'Authorization': localStorage.getItem('accessToken')},
            });
            const payment = (this.state.payment || []).map((p) => (
                p.id === form.id
                    ? {
                        ...p,
                        parentId: form.parentId,
                        description: form.description,
                        amount: {...(p.amount || {}), value: payload.value, unit: form.unit},
                    }
                    : p
            ));
            this.setState({payment, editSaving: false, showEditModal: false, editForm: null});
        } catch (e) {
            this.setState({editSaving: false});
            window.alert('ذخیره فاکتور ناموفق بود');
        }
    }

    confirmDeletePayment = async () => {
        const target = this.state.deleteTarget;
        if (!target?.id) return;
        this.setState({deleteLoading: true});
        try {
            await axios.delete(`${API_BASE_URL}/api/v1/supervisor/paymentHistory/${target.id}`, {
                headers: {'Authorization': localStorage.getItem('accessToken')},
            });
            this.setState({
                payment: (this.state.payment || []).filter((p) => p.id !== target.id),
                deleteLoading: false,
                showDeleteModal: false,
                deleteTarget: null,
                listPage: 1,
            });
        } catch (e) {
            this.setState({deleteLoading: false});
            window.alert('حذف فاکتور ناموفق بود');
        }
    }

    downloadFile = async (file) => {
        const info = paymentFileInfo(file);
        if (!info) return;
        const filename = info.name;

        axios.get(`${API_BASE_URL}/api/v1/supervisor/file/${info.id}`, {responseType: "blob", headers: {Authorization: localStorage.getItem("accessToken")}}).then(response => response.data)
            .then((blob) => {
                if (blob !== null) {
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                }
            }).catch(() => {
            if (localStorage.getItem('role') === 'MANAGER') {
                axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.get(`${API_BASE_URL}/api/v1/supervisor/file/${info.id}`, {responseType: "blob", headers: {Authorization: localStorage.getItem("accessToken")}}).then(response => response.data)
                                .then((blob) => {
                                    if (blob !== null) {
                                        var url = window.URL.createObjectURL(blob);
                                        var a = document.createElement('a');
                                        a.href = url;
                                        a.download = filename;
                                        document.body.appendChild(a);
                                        a.click();
                                        a.remove();
                                    }

                                })
                        } else {
                            window.location = '/'
                        }
                    })
            } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.get(`${API_BASE_URL}/api/v1/supervisor/file/${info.id}`, {responseType: "blob", headers: {Authorization: localStorage.getItem("accessToken")}}).then(response => response.data)
                                .then((blob) => {
                                    if (blob !== null) {
                                        var url = window.URL.createObjectURL(blob);
                                        var a = document.createElement('a');
                                        a.href = url;
                                        a.download = filename;
                                        document.body.appendChild(a);
                                        a.click();
                                        a.remove();
                                    }

                                })
                        } else {
                            window.location = '/'
                        }
                    })
            }
        })
    }
}

export default PaymentHistory;